module.exports = __webpack_public_path__ + "img/symbol_5.2d95374b.png";